import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import useMeasure from 'react-use-measure';
import { flatten } from 'lodash';
import DataCard from '@/business-components/dataCard';
import LineChart from '@/components/charts/line';
import 'rc-tabs/assets/index.css';
// import { formatCount } from '@/utils/format';
import ChartHeader from '@/business-components/chart-header';
import Chart from '@/business-components/chart';
import Tooltip from '@/components/tooltip';
import CustomEmpty from '@/business-components/CustomEmpty';
import styles from './index.module.scss';

export type OperateProps = {
  data;
  hasUnlock?: boolean;
};

const Operate: React.FC<OperateProps> = ({ data, hasUnlock }) => {
  const [cardRef, cardStyle] = useMeasure();
  // console.log(data);
  const [dataEmpty, setDataEmpty] = useState<boolean>(false);
  useEffect(() => {
    const dataList: any = flatten(data?.map(item => item.list));
    setDataEmpty(() => {
      return !dataList?.length || dataList?.every(item => !item.value);
    });
  }, [data]);
  return (
    <>
      <ChartHeader title="经营能力" titleFontSize={18} className={styles.header} />
      {hasUnlock ? (
        <div className={classNames('flex-row-nowrap', 'flex-between-start', styles.organize, styles.gapStyle)}>
          <div className={styles.leftContent} ref={cardRef}>
            {data?.map((item, index) => (
              <DataCard
                key={index}
                brandName={item?.chName}
                indicatorData={[
                  {
                    indicatorName: '当月线上营收指数',
                    indicatorNum: item?.revenueAmount?.toFixed(2),
                  },
                  {
                    indicatorName: '当月线上营收环比增速',
                    indicatorNum: item?.revenueRate + '%',
                  },
                ]}
              />
            ))}
          </div>
          <Chart
            title={
              <>
                非大促期销售额占比
                <Tooltip
                  title={
                    <>
                      <p>
                        品牌某月近1年（不含6月、11月）总销售额占比，反映该品牌旗下产品除618和双11大促外的平日销售情况。
                      </p>
                      <p>数据来源：任拓情报通</p>
                    </>
                  }
                />
              </>
            }
            titleFontSize={16}
            dateSubTitle={false}
            panelClassName={styles.rightContent}
            className={styles.title}
          >
            {dataEmpty ? (
              <CustomEmpty style={{ height: cardStyle?.height - 82 }} className={styles.emptyState} />
            ) : (
              <LineChart
                data={flatten(data?.map(item => item.list))}
                xField="countTimeStr"
                yField="value"
                lField="chName"
                yLabel={'%'}
                tooltipName="近一年非大促期销售额占比"
                height={cardStyle?.height - 82}
                scale={{
                  value: {
                    min: 0,
                  },
                }}
              />
            )}
          </Chart>
        </div>
      ) : (
        <div className={styles.cardItem}>
          <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
        </div>
      )}
    </>
  );
};

export default Operate;
